export enum SessionDataSource {
    eventTool = 'eventTool',
    year2023 = 'year2023',
    year2024 = 'year2024',
    year2025 = 'year2025',
};
